import { useEffect, useRef, useState } from "react";
import { throttle } from "lodash";
import useMediaQueries from "hooks/useMediaQueries";
import { useContent } from "contexts/contentContext/contentContext";

const TOP_PIXELS_TO_TRIGGER_CHANGES = 102;
const TOP_PIXELS_TO_TRIGGER_CHANGES_WITH_PROMO = 172;
const TOP_PIXELS_TO_TRIGGER_CHANGES_WITH_PROMO_MOBILE = 372;
const MILISECONDS_THROTTLE_VALUE = 100;

const useStickyDetection = () => {
  const [isSticky, setIsSticky] = useState(false);
  const { getBlackFridayTime } = useContent();
  const { mobileCondition } = useMediaQueries();
  const targetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      const target = targetRef.current;
      if (target) {
        const { top } = target.getBoundingClientRect();
        setIsSticky(
          top <
            (getBlackFridayTime()
              ? mobileCondition
                ? TOP_PIXELS_TO_TRIGGER_CHANGES_WITH_PROMO_MOBILE
                : TOP_PIXELS_TO_TRIGGER_CHANGES_WITH_PROMO
              : TOP_PIXELS_TO_TRIGGER_CHANGES)
        );
      }
    };

    const throttleScroll = throttle(() => {
      handleScroll();
    }, MILISECONDS_THROTTLE_VALUE);

    window.addEventListener("scroll", throttleScroll);

    return () => {
      window.removeEventListener("scroll", throttleScroll);
    };
  }, [getBlackFridayTime()]);

  return { isSticky, targetRef };
};

export default useStickyDetection;
